import utilities from '@/helpers/utilities';

export default {
    build() {
        return {
            name: '',
            isInUse: false,
            isActive: true,
            officeId: 0,
        };
    },

    toForm(obj) {
        return utilities.toForm(obj, this.build());
    },

    toPayload(obj) {
        return utilities.toPayload(obj);
    },
};



// WEBPACK FOOTER //
// ./src/helpers/entities/ApproverType.js